import { render, staticRenderFns } from "./Sso.vue?vue&type=template&id=c5e151cc&scoped=true&"
import script from "./Sso.vue?vue&type=script&lang=js&"
export * from "./Sso.vue?vue&type=script&lang=js&"
import style0 from "./Sso.vue?vue&type=style&index=0&id=c5e151cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e151cc",
  null
  
)

export default component.exports